import React from 'react';
import PropTypes from 'prop-types';
import { get, find, sampleSize } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import { getPlanRouteProps } from '@bd/bdcore-data/build/Plans/selectors';

import { colors } from '../styles';

const styles = css`
  width: 100%;
  height: 100%;
  margin: 0 0 30px 0;
  .PlanCard_wrapper {
    display: flex;
    background-color: #f3f3f3;
    height: 100%;
  }
  .PlanCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .PlanCard_media {
    padding: 10px;
    img {
      width: 100%;
      height: 193px;
      object-fit: cover;
    }
  }
  .PlanCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    h4 {
      margin: 0;
      a {
        font-weight: bold;
        font-size: 28px;
        color: ${colors.brand1};
        letter-spacing: 0.01px;
      }
    }
    .PlanCard_priceWrapper {
      border-top: 1px solid ${colors.neutral};
      border-bottom: 1px solid ${colors.neutral};
      display: flex;
      width: 45%;
      background-color: ${colors.neutral};
      align-items: center;
      justify-content: center;
      .PlanCard_priceValue {
        font-size: 19px;
        font-weight: 300;
        margin: 0;
      }
    }
    .PlanCard_textList {
      list-style: none;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid ${colors.neutral};
      flex-grow: 1;
    }
    .PlanCard_listHeader {
      font-size: 13px;
      font-weight: 300;
      line-height: 1;
      border-top: 1px solid ${colors.neutral};
      padding: 10px;
      display: block;
      color: ${colors.brand2};
      &-submenu {
        background-image: url('/images/icon-triangle-gold.svg');
        background-position: 95% center;
        background-repeat: no-repeat;
      }
    }
    .HomeCard_iconList {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0 5px 0 15px;
      border-top: 1px solid #E0E2E2;
      border-bottom: 1px solid #E0E2E2;
      height: 72px;
      align-items: center;
      height: 105px;
      @media(min-width: 450px) {
        padding: 0;
        margin-top: 20px;
      }
      li {
        text-align: left;
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #E0E2E2;
        &:last-child {
          border-right: 0;
        }
        span {
          display: block;
          font-weight: 500;
        }
        b {
          font-weight: bold;
        }
        &:last-child {
          width: 40%;
        }
        .HomeCard_iconListValue {
          font-size: 16px;
          color: #353637;
          letter-spacing: 0.31px;
        }
        a {
          color: ${colors.brand2};
          font-weight: 700;
        }
        .HomeCard_linkIcon {
          width: 13px;
          height: 13px;
          margin: 5px 0 0 0;
        }
      }
    }
    .PlanCard_buttonWrapper {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      .PlanCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: #6C6C6C;
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
      }
      .PlanCard_detailButton {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.brand2};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
  .Extra_Padding {
    padding: 0 30px;
  }

  .CommunityPlans_amenities {
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    color: #62676B;
    letter-spacing: 0.11px;
    margin-top: -15px;
    font-weight: 500;
  }
  .CommunityPlans_viewPlan {
    height: 60px;
    background-color: ${colors.brand1};
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 2.7px;
    text-align: center;
    text-transform: uppercase;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand1};
      transition: all .3s ease-out;
    }
  }
  .CommunityPlans_h3 {
    display: flex;
    align-items: center;
    font-weight: bold !important;
    font-size: 26px !important;
    color: ${colors.brand2} !important;
    letter-spacing: 0.46px !important;
    margin-bottom: 0 !important;
    padding: 20px 30px !important;
    span {
      font-weight: 300;
      font-size: 22px;
      color: #353637;
      letter-spacing: 0.77px;
    }
  }

  .Plan_stories {
    margin-bottom: 15px;
  }
`;
function getCommunityModelProperty(community, plan, field) {
  let communityMatch = null;
  if (community) {
    communityMatch = find(plan.communities, ['community', community._id]);
  }
  return get(communityMatch, `communityModelProperties.${field}`, get(plan, field));
}

const planSeries = (plan, community, series, field) => {
  let communityMatch = null;
  let seriesField = null;
  if (community) {
    communityMatch = find(plan.communities, ['community', community._id]);
  }
  if (series) {
    const seriesPriceCommunity = find(communityMatch.communityModelProperties.series, ['name', series]);
    seriesField = get(seriesPriceCommunity, field);
  }
  return seriesField;
};

const getPlanPhotoModelProperty = (id, photos) => {
  return photos.filter(photo => {
    if (photo.hiddenCommunities) {
      return !photo.hiddenCommunities[id];
    }
    return true;
  });
};

function PlanCard({ community, plan, series }) {
  const planSeriesPrice = planSeries(plan, community, series, 'price');
  const price = planSeriesPrice || getCommunityModelProperty(community, plan, 'price');
  const planSeriesGarages = planSeries(plan, community, series, 'garages');
  const garages = planSeriesGarages || getCommunityModelProperty(community, plan, 'garages') || get(plan, 'garages');
  const beds = plan.beds_range ? plan.beds_range : plan.beds;
  const bathsFull = plan.baths_range ? plan.baths_range : plan.bathsFull;
  const sqft = getCommunityModelProperty(community, plan, 'sqft') || get(plan, 'sqft');
  const cardPhoto = sampleSize(getPlanPhotoModelProperty(community._id, get(plan, 'elevationPhotos')), 1);
  const planCardPhoto = get(cardPhoto[0], 'contentUrl') || get(plan, 'elevationPhotos[0].contentUrl');
  return (
    <div className={styles}>
      <div className="PlanCard_wrapper">
        <div className="PlanCard_inner">
          <div className="PlanCard_media">
            <Link name="plan-detail" params={getPlanRouteProps(plan, { community })}>
              <Image
                src={planCardPhoto}
                alt={get(plan, 'name')}
                width={475}
                height={315}
                exact
              />
            </Link>
          </div>
          <div className="PlanCard_content">
            <h4 className="Extra_Padding">
              <Link name="plan-detail" plan={plan}>
                {get(plan, 'name')}
              </Link>
            </h4>
            <ul className="HomeCard_iconList">
              {
                beds &&
                <li>
                  <img src="/images/icon-beds.svg" alt="Icon Beds" />
                  <span className="HomeCard_iconListValue"><b>{beds}</b></span>
                  <span className="HomeCard_iconListValue">Beds</span>
                </li>
              }
              {
                bathsFull &&
                <li>
                  <img src="/images/icon-baths.svg" alt="Icon Baths" />
                  <span className="HomeCard_iconListValue"><b>{bathsFull} {get(plan, 'bathsHalf', 0) > 0 && !plan.baths_range && '.5'}</b></span>
                  <span className="HomeCard_iconListValue">Baths</span>
                </li>
              }
              {
                sqft &&
                <li>
                  <img src="/images/icon-sqft.svg" alt="Icon Sqft" />
                  <span className="HomeCard_iconListValue"><b>{numeral(sqft).format('0,0')}</b></span>
                  <span className="HomeCard_iconListValue">SQFT</span>
                </li>
              }
              {
                garages &&
                <li>
                  <img src="/images/icon-garage.svg" alt="Icon Garage" />
                  <span className="HomeCard_iconListValue"><b>{garages}</b></span>
                  <span className="HomeCard_iconListValue">Cars</span>
                </li>
              }
            </ul>
            {
              price &&
              <h3 className="Extra_Padding CommunityPlans_h3">
                <span>Starting At:&nbsp;</span>
                {numeral(price).format('$0,0')}
              </h3>
            }
            <span className="Extra_Padding Plan_stories"><b>Stories: </b>{plan.stories}</span>
            <Link name="plan-detail" params={getPlanRouteProps(plan, { community })} className="CommunityPlans_viewPlan">
            View Plan
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

PlanCard.propTypes = {
  community: PropTypes.object,
  plan: PropTypes.object.isRequired,
  series: PropTypes.string,
};

PlanCard.defaultProps = {
  community: undefined,
  series: undefined,
};

export default withData({
  community: true,
  plan: true,
})(PlanCard);



// WEBPACK FOOTER //
// ./src/components/PlanCard.js